import * as PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"

import Picture from "./Picture"
import { pushDatalayer } from "../helpers"

const Logo = ({ modifier, logo }) => {
  return typeof logo === "object" ? (
    <Link to={logo.url} className={`logo ${modifier}`} title={logo.text} onClick={() => pushDatalayer("logoClick", "Logo", "Redirect")}>
      <Picture src={logo.images.icon.url} alt={logo.images.icon.alt} className="logo__image" useWebp>
        <img src={logo.images.icon.url} loading="eager" alt={logo.images.icon.alt} className="logo__image" width="auto" height="100%" />
      </Picture>
    </Link>
  ) : (
    <Link to="/" className={`logo ${modifier}`} onClick={() => pushDatalayer("logoClick", "Logo", "Redirect")}>
      <Picture src={logo} alt="" className="logo__image" useWebp>
        <img src={logo} loading="eager" alt="" className="logo__image" width="auto" height="100%" />
      </Picture>
    </Link>
  )
}

Logo.propTypes = {
  modifier: PropTypes.string,
  logo: PropTypes.objectOf(PropTypes.any) || PropTypes.string
}

Logo.defaultProps = {
  modifier: "",
  logo: null
}

export default Logo
